import { ToggleSwitchPassThrough } from "primeng/toggleswitch";

export const ToggleSwitchTelekomPT: ToggleSwitchPassThrough = {
    handle: {
        class: "border-1 border-transparent"
    }
};
